<script>
export default {
  props: {
    userEmail: {
      type: String,
      default: '',
    },
    returnUrl: {
      type: String,
      default: ''
    },
    providerDetails: {
      type: Object,
      default: function() {
        return {}
      }
    }
  }
}
</script>
